import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ContactUsComponent } from '../pages/contact-us/contact-us.component';

export function messageScheme() {
    // return new SchemeBuilder()
    //   .addTextField('email', 'Email', null, null, 'outline')
    //   .addHiddenField('url')
    //   .addHiddenField('time')
    //   .addTextAreaField('message', 'Message', null, null, 'outline', 5, 8)
    //   .build();
    return {};
}

@Component({
    selector: 'iea-app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ContactUsComponent, RouterModule, NgOptimizedImage],
    standalone: true,
})
export class FooterComponent {
    year = new Date().getFullYear();
}
